module.exports = __webpack_public_path__ + "media/images/loading-eaa73d33d0d06d5bcb8e13ee6b01850d.gif";